import React, { useEffect, useState } from "react";
import {
	CircularProgress,
	Accordion,
	AccordionSummary,
	Dialog,
	DialogActions,
	TextField,
	DialogContent,
	DialogTitle,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import GetAppIcon from "@material-ui/icons/GetApp";
import SearchIcon from "@material-ui/icons/Search";
import HumburgerButton from "../shared/HumburgerButton";
import useStore from "../shared/store";
import { api } from "../shared/utilities/api";
import apiConfigs from "../shared/utilities/apiConfigs";
import SendIcon from "@material-ui/icons/Send";
import CloseIcon from "@material-ui/icons/Close";

let emrURL = process.env.PORTON_EMR_API;

// ─── Inline styles ─────────────────────────────────────────────────────────────
const injectStyles = () => {
	if (document.getElementById("message-page-styles")) return;
	const style = document.createElement("style");
	style.id = "message-page-styles";
	style.textContent = `
		@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@600;700;800&family=Inter:wght@400;500;600&display=swap');

		.mp-wrap, .mp-wrap *, .mp-wrap *::before, .mp-wrap *::after {
			box-sizing: border-box;
		}
		.mp-wrap {
			font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif;
			padding: 32px 40px;
			min-height: 100vh;
		}

		/* ── Page title ── */
		.mp-title {
			display: flex;
			align-items: center;
			gap: 14px;
			margin-bottom: 20px;
		}
		.mp-title__text {
			font-family: 'Manrope', sans-serif;
			font-size: 28px;
			font-weight: 800;
			color: #18181A;
			letter-spacing: -0.02em;
			white-space: nowrap;
		}
		.mp-title__line {
			flex: 1;
			height: 2px;
			background: linear-gradient(90deg, rgba(228,112,41,0.45) 0%, transparent 100%);
			border-radius: 2px;
		}

		/* ── Search ── */
		.mp-search {
			display: flex;
			align-items: center;
			background: #ffffff;
			border: 1.5px solid #E47029;
			border-radius: 10px;
			padding: 8px 14px;
			margin-bottom: 20px;
			gap: 8px;
		}
		.mp-search .MuiInputBase-root {
			flex: 1;
			font-size: 14px;
			font-family: 'Inter', sans-serif;
		}
		.mp-search .MuiIconButton-root {
			color: #E47029;
			padding: 6px;
		}

		/* ── Patient card ── */
		.mp-patient-card {
			background: #ffffff;
			border: 1.5px solid rgba(0,0,0,0.07);
			border-radius: 16px;
			margin-bottom: 14px;
			overflow: hidden;
			box-shadow: 0 1px 3px rgba(0,0,0,0.04), 0 4px 12px -4px rgba(0,0,0,0.06);
		}
		.mp-patient-card .MuiAccordion-root {
			box-shadow: none !important;
			border-radius: 0 !important;
			background: transparent;
			margin: 0 !important;
		}
		.mp-patient-card .MuiAccordion-root::before {
			display: none !important;
		}
		.mp-patient-card .MuiAccordionSummary-root {
			padding: 0 22px;
			min-height: 64px !important;
			border-bottom: 1.5px solid rgba(0,0,0,0.06);
			transition: background 0.15s;
		}
		.mp-patient-card .MuiAccordionSummary-root:hover {
			background: #FAFAFA;
		}
		.mp-patient-card .MuiAccordionSummary-content {
			margin: 14px 0 !important;
			display: flex;
			align-items: center;
			gap: 12px;
		}
		.mp-patient-card .MuiAccordionSummary-expandIcon {
			color: #9A9A9F;
		}
		.mp-patient-card .MuiAccordionDetails-root {
			padding: 0;
			display: block;
		}
		.mp-patient-card .MuiCardContent-root {
			padding: 0 !important;
		}

		/* ── HIN avatar + label ── */
		.mp-hin-avatar {
			width: 38px;
			height: 38px;
			border-radius: 10px;
			background: #FEF0E7;
			color: #E47029;
			display: flex;
			align-items: center;
			justify-content: center;
			font-family: 'Manrope', sans-serif;
			font-weight: 800;
			font-size: 10px;
			flex-shrink: 0;
			text-transform: uppercase;
			letter-spacing: 0.04em;
		}
		.mp-hin-info {}
		.mp-hin-label {
			font-size: 10.5px;
			color: #9A9A9F;
			text-transform: uppercase;
			letter-spacing: 0.05em;
			margin-bottom: 2px;
		}
		.mp-hin-value {
			font-family: 'Manrope', sans-serif;
			font-size: 14px;
			font-weight: 700;
			color: #18181A;
		}
		.mp-unread-badge {
			display: inline-flex;
			align-items: center;
			font-size: 11px;
			font-weight: 700;
			padding: 3px 9px;
			border-radius: 20px;
			background: #FEF0E7;
			color: #D45F1A;
			white-space: nowrap;
			margin-left: 8px;
		}
.mp-viewed-badge {
			display: inline-flex;
			align-items: center;
			font-size: 11px;
			font-weight: 700;
			padding: 3px 9px;
			border-radius: 20px;
			background: #EEF0F2;
			color: #5F6368;
			white-space: nowrap;
			margin-left: 8px;
		}
		.mp-file-state {
			font-size: 10.5px;
			font-weight: 700;
			padding: 2px 8px;
			border-radius: 20px;
			margin-left: 6px;
			white-space: nowrap;
			background: #EEF0F2;
			color: #5F6368;
		}
		.mp-file-state.new { background: #FDE7DA; color: #B34E12; }
		.mp-file-state.added { background: #E3F4EC; color: #1E7B52; }
		.mp-unread-dot {
			width: 6px;
			height: 6px;
			border-radius: 50%;
			background: #E47029;
			margin-right: 5px;
			flex-shrink: 0;
		}

		/* ── Message rows ── */
		.mp-message-body {
			padding: 0 22px 8px;
		}
		.mp-message-row {
			display: flex;
			align-items: flex-start;
			justify-content: space-between;
			padding: 14px 0;
			border-bottom: 1px solid rgba(0,0,0,0.05);
			gap: 16px;
		}
		.mp-message-row:last-child {
			border-bottom: none;
		}
		.mp-message-date {
			font-size: 11.5px;
			color: #9A9A9F;
			margin-bottom: 4px;
		}
		.mp-message-file {
			font-size: 13.5px;
			font-weight: 600;
			color: #18181A;
			display: flex;
			align-items: center;
			gap: 6px;
		}
		.mp-message-file.unread {
			color: #E47029;
		}
		.mp-btn-download {
			display: inline-flex;
			align-items: center;
			gap: 6px;
			padding: 7px 14px;
			border-radius: 8px;
			background: #FEF0E7;
			color: #E47029;
			font-size: 12.5px;
			font-weight: 700;
			font-family: 'Inter', sans-serif;
			border: none;
			cursor: pointer;
			white-space: nowrap;
			transition: background 0.15s ease;
		}
		.mp-btn-download:hover {
			background: #FBCFAC;
		}

		/* ── Card footer (Send Email) ── */
		.mp-card-footer {
			padding: 12px 22px;
			background: #FAFAFA;
			border-top: 1px solid rgba(0,0,0,0.05);
			display: flex;
			justify-content: flex-end;
		}
		.mp-btn-email {
			display: inline-flex;
			align-items: center;
			gap: 6px;
			padding: 8px 16px;
			border-radius: 8px;
			background: #E47029;
			color: #ffffff;
			font-size: 12.5px;
			font-weight: 700;
			font-family: 'Inter', sans-serif;
			border: none;
			cursor: pointer;
			transition: background 0.15s ease;
		}
		.mp-btn-email:hover {
			background: #B94D1A;
		}

		/* ── Loading / error / empty states ── */
		.mp-center {
			display: flex;
			justify-content: center;
			align-items: center;
			height: 100px;
		}
		.mp-empty {
			background: #ffffff;
			border: 1.5px solid rgba(0,0,0,0.07);
			border-radius: 16px;
			padding: 40px;
			text-align: center;
		}
		.mp-empty__text {
			font-size: 14px;
			color: #9A9A9F;
			line-height: 1.6;
		}
		.mp-error {
			font-size: 14px;
			color: #A32D2D;
			padding: 12px 0;
		}

		/* ── Email Dialog overrides ── */
		.mp-dialog {
			font-family: 'Inter', sans-serif;
		}
		.mp-dialog .MuiDialog-paper {
			border-radius: 16px;
			overflow: hidden;
		}
		.mp-dialog-title {
			font-family: 'Manrope', sans-serif !important;
			font-size: 18px !important;
			font-weight: 700 !important;
			color: #E47029 !important;
			padding: 20px 28px !important;
			background: #FEF0E7;
			border-bottom: 1px solid rgba(228,112,41,0.15);
		}
		.mp-dialog-content {
			padding: 24px 28px !important;
		}
		.mp-dialog-desc {
			font-size: 13px;
			color: #9A9A9F;
			margin-bottom: 16px;
		}
		.mp-dialog-content .MuiTextField-root {
			margin-bottom: 14px;
		}
		.mp-dialog-content .MuiOutlinedInput-root {
			border-radius: 10px;
			font-family: 'Inter', sans-serif;
			font-size: 14px;
		}
		.mp-dialog-content label.Mui-focused {
			color: #E47029 !important;
		}
		.mp-dialog-content .MuiOutlinedInput-root.Mui-focused fieldset {
			border-color: #E47029 !important;
		}
		.mp-dialog-actions {
			padding: 18px 28px !important;
			background: #FEF0E7;
			border-top: 1px solid rgba(228,112,41,0.15);
		}
		.mp-btn-cancel {
			padding: 8px 18px;
			border-radius: 8px;
			border: 1.5px solid #E47029;
			background: transparent;
			color: #E47029;
			font-size: 13px;
			font-weight: 700;
			font-family: 'Inter', sans-serif;
			cursor: pointer;
			display: inline-flex;
			align-items: center;
			gap: 6px;
			transition: background 0.15s ease;
		}
		.mp-btn-cancel:hover {
			background: rgba(228,112,41,0.08);
		}
		.mp-btn-cancel:disabled {
			opacity: 0.5;
			cursor: not-allowed;
		}
		.mp-btn-send {
			padding: 8px 20px;
			border-radius: 8px;
			background: #E47029;
			color: #ffffff;
			border: none;
			font-size: 13px;
			font-weight: 700;
			font-family: 'Inter', sans-serif;
			cursor: pointer;
			display: inline-flex;
			align-items: center;
			gap: 8px;
			transition: background 0.15s ease;
		}
		.mp-btn-send:hover:not(:disabled) {
			background: #B94D1A;
		}
		.mp-btn-send:disabled {
			opacity: 0.7;
			cursor: not-allowed;
		}
	`;
	document.head.appendChild(style);
};

// ─── Helpers ───────────────────────────────────────────────────────────────────
function extractFileName(url) {
	const parsedUrl = new URL(url);
	const pathSegments = parsedUrl.pathname.split("/");
	let fileName = decodeURIComponent(pathSegments[pathSegments.length - 1]);
	const extensionIndex = fileName.lastIndexOf(".");
	if (extensionIndex !== -1) {
		const baseName = fileName.substring(0, extensionIndex);
		const extension = fileName.substring(extensionIndex);
		if (baseName.endsWith(extension)) {
			fileName = baseName;
		}
	}
	return fileName;
}

// ─── File icon ─────────────────────────────────────────────────────────────────
const FileIcon = ({ color = "#9A9A9F" }) => (
	<svg viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" width="14" height="14" aria-hidden="true">
		<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
		<polyline points="14 2 14 8 20 8" />
	</svg>
);

// ─── Main component ────────────────────────────────────────────────────────────
const MessagePage = ({ smallScreenView, handleMenuClick }) => {
	const { user } = useStore();
	const [messages, setMessages] = useState([]);
	const [groupedMessages, setGroupedMessages] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [searchQuery, setSearchQuery] = useState("");
	const [expandedPatients, setExpandedPatients] = useState({});

	const getProviderMessages = async () => {
		try {
			const userId = user._id;
			const orgId = user.orgs[0];
			const result = await api(
				apiConfigs.baseOption("get", `providerMessages/${orgId}_${userId}`)
			);
			setMessages(result.data.messages || []);
			let groupedByPatients = {};
			if (result?.data?.messages?.length) {
				result.data.messages.forEach((message) => {
					if (groupedByPatients[message.patientDemoNo]) {
						groupedByPatients[message.patientDemoNo].push(message);
					} else {
						groupedByPatients[message.patientDemoNo] = [message];
					}
				});
				setGroupedMessages(groupedByPatients);
			}
		} catch (error) {
			setError("Messages could not be loaded. Please refresh the page.");
		} finally {
			setLoading(false);
		}
	};

	const handleAccordionToggle = (patientHin) => {
		setExpandedPatients((prev) => ({
			...prev,
			[patientHin]: !prev[patientHin],
		}));
	};

	const handleSearch = () => {
		if (searchQuery.trim() === "") return;
		const filteredMessages = messages.filter(
			(message) =>
				message.patientDemoNo.includes(searchQuery) ||
				new Date(message.date).toLocaleString().includes(searchQuery) ||
				extractFileName(message.url).toLowerCase().includes(searchQuery.toLowerCase())
		);
		const filteredByHIN = filteredMessages.reduce((acc, item) => {
			if (!acc[item.patientDemoNo]) acc[item.patientDemoNo] = [];
			acc[item.patientDemoNo].push(item);
			return acc;
		}, {});
		setGroupedMessages(filteredByHIN);
	};

	const handleDownloadClick = async (message) => {
		window.open(message.url, "_blank");
		try {
			const userId = user._id;
			const orgId = user.orgs[0];
			await api(
				apiConfigs.baseOption(
					"post",
					`providerMessages/${orgId}_${userId}/${message._id}/mark-as-read`
				)
			);
			getProviderMessages();
		} catch (err) {
			// fail silently
		}
	};

	const hasUnreadMessages = (msgs) => msgs.some((m) => !m.read);
	const unreadCount = (msgs) => msgs.filter((m) => !m.read).length;

	useEffect(() => {
		injectStyles();
		getProviderMessages();
		const path = window.location.pathname;
		const match = path.match(/hin=(\d+)/);
		if (match) setSearchQuery(match[1]);
	}, []);

	useEffect(() => {
		if (user) getProviderMessages();
	}, [user]);

	useEffect(() => {
		handleSearch();
	}, [searchQuery]);

	useEffect(() => {
		if (!loading && searchQuery && messages.length) handleSearch();
	}, [loading, searchQuery, messages]);

	// ── Email dialog state (same as original) ──
	const [isShowEmailDialog, setIsShowEmailDialog] = useState(false);
	const [patient, setPatient] = useState(null);
	const [emailData, setEmailData] = useState({ subject: "", content: "", name: "", to: "" });
	const [isSending, setIsSending] = useState(false);

	const handleEmailDataInput = (event) => {
		setEmailData((data) => ({ ...data, [event.target.name]: event.target.value }));
	};

	const handleEmailSend = async () => {
		try {
			await api(
				apiConfigs.baseOption("post", "plugin/sendMessage", {
					data: {
						email: emailData.to,
						content: emailData.content,
						subject: emailData.subject,
						sentFrom: "Clinic",
						orgId: user.orgs[0],
						patient: emailData.name,
					},
				})
			);
			alert("Email sent successfully.");
			setIsShowEmailDialog(false);
		} catch (err) {
			alert("Unable to send the email");
		}
	};

	const onSendClick = async () => {
		setIsSending(true);
		try {
			await handleEmailSend();
		} finally {
			setIsSending(false);
		}
	};

	const getPatient = async (patientHin) => {
		try {
			const orgId = user.orgs[0];
			const result = await api(
				apiConfigs.baseOption("get", `orgs/${orgId}/patients/${patientHin}`)
			);
			if (!result.data) throw new Error("Unable to retrieve patient data.");
			setPatient(result.data);
			setEmailData((data) => ({
				...data,
				name: result.data.fullname,
				to: result.data.email,
			}));
		} catch (error) {
			// unable to get the patient
		}
	};

	const showEmailForm = async (patientHin) => {
		setIsShowEmailDialog(true);
		setPatient(null);
		await getPatient(patientHin);
	};

	const hideEmailDialog = () => setIsShowEmailDialog(false);

	return (
		<>
			<HumburgerButton
				smallScreenView={smallScreenView}
				handleMenuClick={handleMenuClick}
			/>

			<div className="mp-wrap">

				{/* ── Page title ── */}
				<div className="mp-title">
					<span className="mp-title__text">Documents Delivered</span>
					<div className="mp-title__line" />
				</div>

				{/* ── Search bar ── */}
				{messages.length > 0 && (
					<div className="mp-search">
						<SearchIcon style={{ color: "#9A9A9F", fontSize: 20 }} />
						<input
							style={{
								flex: 1, border: "none", outline: "none",
								fontSize: 14, fontFamily: "inherit", background: "transparent",
								color: "#18181A",
							}}
							placeholder="Search by HIN, date or filename..."
							value={searchQuery}
							onChange={(e) => setSearchQuery(e.target.value)}
							onKeyDown={(e) => { if (e.key === "Enter") { handleSearch(); e.preventDefault(); } }}
						/>
						<button
							onClick={handleSearch}
							style={{ background: "none", border: "none", cursor: "pointer", color: "#E47029", display: "flex", alignItems: "center" }}
						>
							<SearchIcon style={{ fontSize: 20 }} />
						</button>
					</div>
				)}

				{/* ── Content ── */}
				{loading ? (
					<div className="mp-center">
						<CircularProgress style={{ color: "#E47029" }} />
					</div>
				) : error ? (
					<p className="mp-error">{error}</p>
				) : messages.length > 0 ? (
					<div style={{ display: "flex", flexDirection: "column" }}>
						{Object.keys(groupedMessages).map((patientHin) => {
							const patientMsgs = groupedMessages[patientHin];
							const hasUnread = hasUnreadMessages(patientMsgs);
							const unread = unreadCount(patientMsgs);
							return (
								<div key={patientHin} className="mp-patient-card">
									<Accordion
										expanded={expandedPatients[patientHin] || hasUnread}
										onChange={() => handleAccordionToggle(patientHin)}
										elevation={0}
									>
										<AccordionSummary expandIcon={<ExpandMoreIcon />}>
											<div className="mp-hin-avatar">HIN</div>
											<div className="mp-hin-info">
												<div className="mp-hin-label">Health Identification Number</div>
												<div className="mp-hin-value">{patientHin}</div>
											</div>
											{hasUnread ? (
												<span className="mp-unread-badge">
													<span className="mp-unread-dot" />
													{unread} unread
												</span>
											) : (
												<span className="mp-viewed-badge">All viewed</span>
											)}
										</AccordionSummary>

										<div className="mp-message-body">
											{patientMsgs.map((message) => (
												<div key={message._id} className="mp-message-row">
													<div>
														<div className="mp-message-date">
															{new Date(message.date).toLocaleString()}
														</div>
														<div className={`mp-message-file${!message.read ? " unread" : ""}`}>
															<FileIcon color={!message.read ? "#E47029" : "#9A9A9F"} />
															{extractFileName(message.url)}
															{message.addedToEncounterAt ? (
																<span className="mp-file-state added">✓ Added to encounter</span>
															) : message.read ? (
																<span className="mp-file-state">Viewed</span>
															) : (
																<span className="mp-file-state new">New</span>
															)}
														</div>
													</div>
													<button
														className="mp-btn-download"
														onClick={() => handleDownloadClick(message)}
													>
														<GetAppIcon style={{ fontSize: 14 }} />
														Download
													</button>
												</div>
											))}
										</div>

										<div className="mp-card-footer">
											<button
												className="mp-btn-email"
												onClick={() => showEmailForm(patientHin)}
											>
												<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="13" height="13" aria-hidden="true"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
												Send Email
											</button>
										</div>
									</Accordion>
								</div>
							);
						})}
					</div>
				) : (
					<div className="mp-empty">
						<p className="mp-empty__text">
							There are no messages available at this time. Please check again later.
						</p>
					</div>
				)}
			</div>

			{/* ── Email Dialog ── */}
			<Dialog
				open={isShowEmailDialog}
				onClose={hideEmailDialog}
				maxWidth="sm"
				fullWidth
				className="mp-dialog"
			>
				{!patient ? (
					<div className="mp-center" style={{ minHeight: 200 }}>
						<CircularProgress style={{ color: "#E47029" }} />
					</div>
				) : (
					<>
						<DialogTitle disableTypography className="mp-dialog-title">
							Send Email
						</DialogTitle>

						<DialogContent className="mp-dialog-content">
							<p className="mp-dialog-desc">
								Fill in the details below to send an email to the patient.
							</p>
							<TextField
								label="Patient Name"
								fullWidth
								variant="outlined"
								disabled
								value={patient.fullname}
								style={{ marginBottom: 14 }}
							/>
							<TextField
								label="Email"
								type="email"
								fullWidth
								variant="outlined"
								disabled
								value={patient.email}
								style={{ marginBottom: 14 }}
							/>
							<TextField
								name="subject"
								label="Subject"
								fullWidth
								variant="outlined"
								onChange={handleEmailDataInput}
								style={{ marginBottom: 14 }}
							/>
							<TextField
								name="content"
								label="Message"
								fullWidth
								variant="outlined"
								multiline
								rows={4}
								onChange={handleEmailDataInput}
							/>
						</DialogContent>

						<DialogActions className="mp-dialog-actions">
							<button
								className="mp-btn-cancel"
								onClick={hideEmailDialog}
								disabled={isSending}
							>
								<CloseIcon style={{ fontSize: 14 }} />
								Cancel
							</button>
							<button
								className="mp-btn-send"
								onClick={onSendClick}
								disabled={isSending}
							>
								{isSending ? "Sending..." : "Send"}
								{isSending
									? <CircularProgress size={14} style={{ color: "#fff" }} />
									: <SendIcon style={{ fontSize: 14 }} />
								}
							</button>
						</DialogActions>
					</>
				)}
			</Dialog>
		</>
	);
};

export default MessagePage;